import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import greenLogo from "../../../assets/images/slideKick/logo.png";

const Over = (props) => {
  const over = _.get(props, "ParamsReducer.gameObj.over");
  const back_to_menu = _.get(over, "back_to_menu", "Back to Menu");
  const end_message = _.get(over, "end_message", "The meeting has ended!");
  // const gameapart_title = _.get(over, "gameapart_title", "Heylime SlideKick");
  const presented_with = _.get(over, "presented_with", "Presented with");

  return (
    <div className="sldieKick-over-container">
      <div className="main-content">
        <p className="meeting-ended-text">{end_message}</p>
        <div className="text-center">
          <p className="presented-with-text">{presented_with}</p>
          <p className="gameapart-title">heyLIME SlideKick</p>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Over);
